import axios from "axios";
import { getToken } from "../../Utils/UpdateUsersState";

// Edit existing user
const editUser = async (id, firstName, lastName) => {
  try {
    const res = await axios.patch(
      `${process.env.REACT_APP_BACKEND_URL}user/edit/`,
      {
        name: firstName + " " + lastName,
      },
      {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      }
    );
    return res;
  } catch (e) {
    console.log(e, "error");
    throw e;
  }
};

const getAdminPages = async () => {
  try {
    const res = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}user/page-access/`,
      {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      }
    );
    return res;
  } catch (e) {
    console.log(e, "error");
    return e;
  }
};

// Grant or restrict page access
const userPageAccess = async (id, pageName, act) => {
  try {
    const res = await axios.post(
      `${process.env.REACT_APP_BACKEND_URL}user/page-access/`,
      {
        page_name: pageName,
        action: act,
      },
      {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      }
    );
    return res;
  } catch (e) {
    console.log(e, "error");
    return e;
  }
};

// Reset user's password
const passwordReset = async (id, password) => {
  try {
    const payload = {
      new_password: password,
    };
    const res = await axios.post(
      `${process.env.REACT_APP_BACKEND_URL}user/password-reset/`,
      payload,
      {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      }
    );
    return res;
  } catch (e) {
    console.log(e, "error");
    return e;
  }
};

const deleteUser = async (role) => {
  try {
    const res = await axios.delete(
      `${process.env.REACT_APP_BACKEND_URL}user/delete/`,
      {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      }
    );
    return res;
  } catch (e) {
    console.log(e, "error");
    return e;
  }
};

const uploadProfilePicture = async (file) => {
  try {
    const formData = new FormData();
    formData.append("profile_picture", file);

    const res = await axios.patch(
      `${process.env.REACT_APP_BACKEND_URL}user/profile-picture/`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${getToken()}`,
          "Content-Type": "multipart/form-data",
        },
      }
    );
    return res;
  } catch (e) {
    console.log(e, "error");
    return e;
  }
};

export {
  userPageAccess,
  editUser,
  deleteUser,
  passwordReset,
  getAdminPages,
  uploadProfilePicture,
};
